<ng-template #modalLG let-modal style="border-radius: 8px">

    <div class="modal-header p-0" style="background-color: transparent;">
        <button type="button" class=" close" style="margin-right: 5px" (click)="modal.dismiss('Cross click')"
                aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div style=" margin: 52px 64px 64px;">
        <div class="pt-2 text-center mb-4">
            <h4 class="size24">{{ isEditMode ? 'Modifier l\'entrepôt' : 'Ajoutez un entrepôt' }}</h4>
        </div>

        <div class="modal-body p-0" tabindex="0" ngbAutofocus>

            <div class="items mb-1">
                <div style="flex-grow: 1;">
                    <label>Nom de l'entrepôt <span class="text-danger">*</span></label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="entrepot.nom"
                           name="nom"
                           placeholder="Entrez le Nom de l'entrepôt"
                           #nomRef="ngModel"
                           [ngClass]="{ 'is-invalid': !!dataError.nom }"
                           (input)="clearFieldError('nom')"
                           required>
                    <div *ngIf="dataError.nom" class="invalid-feedback d-block">
                        {{ dataError.nom }}
                    </div>
                </div>

                <div style="flex-grow: 1;">
                    <label>Code entrepôt <span class="text-danger">*</span></label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="entrepot.code"
                           name="code"
                           placeholder="Entrez le code entrepôt"
                           #codeEntrepotRef="ngModel"
                           [ngClass]="{ 'is-invalid': !!dataError.code }"
                           (input)="clearFieldError('code')"
                           required>
                    <div *ngIf="dataError.code" class="invalid-feedback d-block">
                        {{ dataError.code }}
                    </div>
                </div>
            </div>

            <div class="center mb-1">
                <label>Adresse <span class="text-danger">*</span></label>
                <input type="text"
                       class="form-control"
                       [(ngModel)]="entrepot.adresse"
                       name="adresse"
                       placeholder="Entrez l'adresse"
                       #adresseRef="ngModel"
                       [ngClass]="{ 'is-invalid': !!dataError.adresse }"
                       (input)="clearFieldError('adresse')"
                       required>
                <div *ngIf="dataError.adresse" class="invalid-feedback d-block">
                    {{ dataError.adresse }}
                </div>
            </div>

            <div class="items mb-1">
                <div style="flex-grow: 1;">
                    <label>Ville <span class="text-danger">*</span></label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="entrepot.ville"
                           name="ville"
                           placeholder="Entrez la ville"
                           #villeRef="ngModel"
                           [ngClass]="{ 'is-invalid': !!dataError.ville }"
                           (input)="clearFieldError('ville')"
                           required>
                    <div *ngIf="dataError.ville" class="invalid-feedback d-block">
                        {{ dataError.ville }}
                    </div>
                </div>

                <div style="flex-grow: 1;">
                    <label>Code postal <span class="text-danger">*</span></label>
                    <input type="text"
                           class="form-control"
                           [(ngModel)]="entrepot.code_postal"
                           name="code_postal"
                           placeholder="Entrez le code postal"
                           #code_postalRef="ngModel"
                           [ngClass]="{ 'is-invalid': !!dataError.code_postal }"
                           (input)="clearFieldError('code_postal')"
                           required>
                    <div *ngIf="dataError.code_postal" class="invalid-feedback d-block">
                        {{ dataError.code_postal }}
                    </div>
                </div>
            </div>

            <div class="center mb-1">
                <label>Pays <span class="text-danger">*</span></label>
                <div class="mb-2">
                    <select class="form-control"
                            [(ngModel)]="entrepot.pays"
                            id="basicSelect"
                            name="pays"
                            #paysRef="ngModel"
                            [ngClass]="{ 'is-invalid': !!dataError.pays }"
                            (change)="clearFieldError('pays')"
                            required>
                        <option value="">Choisissez le pays</option>
                        <option value="Tunisie">Tunisie</option>
                    </select>
                    <div *ngIf="dataError.pays" class="invalid-feedback d-block">
                        {{ dataError.pays }}
                    </div>
                </div>
            </div>

        </div>
        <div class="centerButtons">
            <button type="button" class="btn btn-primary"
                    (click)="onSubmit()" rippleEffect
                    [disabled]="loading">
                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                {{ loading ? 'Enregistrement...' : (isEditMode ? 'Modifier' : 'Valider') }}
            </button>
            <button type="button" class="btn " style="color: #808390; background-color: #80839029" (click)="modal.close('Accept click')" [disabled]="loading" rippleEffect>Annuler
            </button>
        </div>

    </div>
</ng-template>
